assertSelectionSetForIdValue